
import { Component, Vue, namespace } from 'nuxt-property-decorator';
import { EventDto } from 'fourwaves-shared';
import WavePath from './WavePath.vue';

const EventsModule = namespace('events');

@Component({
  components: { WavePath },
})
export default class LiveBanner extends Vue {
  @EventsModule.State currentEvent!: EventDto;

  public mounted() {
    document.documentElement.style.setProperty('--with-live-banner', '1');
  }

  public beforeDestroy() {
    document.documentElement.style.removeProperty('--with-live-banner');
  }
}
